<template>
    <div class="loading-overlay">
        <div class="spinner"></div>
    </div>
</template>

<script>
export default {
    name: "LoadingOverlay",
    /* mounted(){
    document.body.classList.add('modal-open');
    },
    beforeUnmount() {
      document.body.classList.remove('modal-open');
    }, */
};
</script>

<style>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(0, 0, 0, 0); */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10100;
}

.spinner {
    border: 16px solid #f3f3f3;
    border-top: 16px solid var(--primary-color);
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>